(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection-heading"]) return;
  try {
    
  (function () {
    if (customElements.get("collapsible-text")) return;

    function debounce(fn, wait) {
      var t;
      return function () {
        var ctx = this,
          args = arguments;
        clearTimeout(t);
        t = setTimeout(function () {
          fn.apply(ctx, args);
        }, wait);
      };
    }

    class CollapsibleText extends HTMLElement {
      connectedCallback() {
        this.content = this.querySelector(".collapsible-text__content");
        this.toggle = this.querySelector(".collapsible-text__toggle");
        if (!this.content || !this.toggle) return;

        this.lines = parseInt(this.dataset.lines, 10) || 3;
        this.moreText = this.dataset.more || "Show more";
        this.lessText = this.dataset.less || "Show less";

        this.toggle.addEventListener("click", this.onToggle.bind(this));
        this._onResize = debounce(this.check.bind(this), 200);
        window.addEventListener("resize", this._onResize);

        // Measure after the browser has laid out the text.
        requestAnimationFrame(this.check.bind(this));
        // Re-measure once web fonts settle (line-height can shift).
        if (document.fonts && document.fonts.ready) {
          document.fonts.ready.then(this.check.bind(this));
        }
      }

      disconnectedCallback() {
        if (this._onResize) window.removeEventListener("resize", this._onResize);
      }

      isOverflowing() {
        var cs = getComputedStyle(this.content);
        var lineHeight = parseFloat(cs.lineHeight);
        if (isNaN(lineHeight)) lineHeight = parseFloat(cs.fontSize) * 1.5;
        var maxHeight = lineHeight * this.lines;
        // scrollHeight is the full content height even while clamped.
        return this.content.scrollHeight > maxHeight + 2;
      }

      check() {
        if (!this.isOverflowing()) {
          this.classList.remove("is-expanded");
          this.toggle.hidden = true;
          this.toggle.setAttribute("aria-expanded", "false");
          this.toggle.textContent = this.moreText;
          return;
        }
        this.toggle.hidden = false;
        var expanded = this.classList.contains("is-expanded");
        this.toggle.textContent = expanded ? this.lessText : this.moreText;
      }

      onToggle() {
        var expanded = this.classList.toggle("is-expanded");
        this.toggle.setAttribute("aria-expanded", expanded ? "true" : "false");
        this.toggle.textContent = expanded ? this.lessText : this.moreText;
      }
    }

    customElements.define("collapsible-text", CollapsibleText);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["top-bar"] && !Shopify.designMode) return;
  try {
    
  let top_bar = document.querySelector('.section-top-bar')?.clientHeight || 0;
  const body = document.querySelector('body');
  body.style.setProperty('--height-topbar', `${top_bar}px`);

  } catch(e) { console.error(e); }
})();
})();
